import { render } from "./thar-right-collection-sec.vue?vue&type=template&id=f8dd9e34&scoped=true"
import script from "./thar-right-collection-sec.vue?vue&type=script&lang=js"
export * from "./thar-right-collection-sec.vue?vue&type=script&lang=js"

import "./thar-right-collection-sec.vue?vue&type=style&index=0&id=f8dd9e34&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8dd9e34"]])

export default __exports__